import {MouseEventHandler} from "react";

import Button from "@/components/button/Button.tsx";

interface CallToActionProps {
  userCanPurchase: boolean;
  handleClick: MouseEventHandler;
  disabled: boolean;
}

export const CTAWithinPlan = ({userCanPurchase, handleClick, disabled}: CallToActionProps) => (
  <>
    <div className="p-2"></div>
    <Button onClick={handleClick} disabled={disabled}>
      {userCanPurchase ? "Purchase" : "Send Request"}
    </Button>
    <a href="/billing/manage-add-ons" target="_blank" className="d-block text-center">
      Manually Upgrade
    </a>
  </>
);
